import { AfterViewInit, Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { ValidatorType } from '@app/core/enums/validator-type.enum';
import { FieldValidator } from '@app/core/model/other/field-validator';
import { AbstractFieldBuilder } from '@app/shared/components/fields/abstract.field';


@Component({
    selector: 'dpe-field-builder',
    templateUrl: './dpe-field-builder.component.html',
    styleUrls: ['./dpe-field-builder.component.scss'],
    standalone: false
})
export class DpeFieldBuilderComponent extends AbstractFieldBuilder<FormControl> implements OnInit, AfterViewInit {
  public Permission = PermissionEnum;
  public dpeList = this.appConfig.DPE_LIST;
  public cssClass: string;

  public ngOnInit(): void {
    if (this.fieldConfig.fieldCode === 'powerLabel') {
      this.cssClass = 'power-color';
    } else if (this.fieldConfig.fieldCode === 'climateLabel') {
      this.cssClass = 'climate-color';
    }
    this.getFieldGroupInfo(['isDisplayed']).next(this.entity['type'] === this.fieldConfig.field?.checkType);
    this.form = new FormGroup({
      field: new FormControl(
        this.fieldInitValue,
        this.computeValidators()
      )
    });
    // Initialise the field in the registry
    this.setFieldValue(this.fieldInitValue);
    this.setFieldInitialValue(this.fieldInitValue);
    this.getNextState();
  }

  public ngAfterViewInit(): void {
    this.setupHooks();

    this.form.controls.field.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.setFieldValue(value);
    });
  }

  public cancel(): void {
    this.form.controls.field.setValue(this.getFieldInitialValue());
    super.cancel();
  }

  public isLabelSelected(label): string {
    return (label === this.form.controls.field.value) ? 'selected-dpe-label' : '';
  }

  public selectDpeValue(value): void {
    this.setFieldValue(value);
    this.form.controls.field.setValue(value);
    this.onClickSave();
  }

  protected computeValidators(): ValidatorFn {
    this.fieldConfig.field?.validators.push(new FieldValidator(
      ValidatorType.NOT_IN_ARRAY,
      this.fieldConfig.field?.fieldValues
    ));
    return super.computeValidators();
  }
}
